<template>
  <div class="main-container">
    <h2 class="text-center mb-4">添加商品</h2>
    <form @submit.prevent="submitForm">
      <div class="mb-3">
        <label for="productId" class="form-label">商品ID</label>
        <input type="text" class="form-control" id="productId" v-model="productId" required>
        <div class="text-danger" v-if="productIdError">请输入商品ID</div>
      </div>
      <div class="mb-3">
        <label for="quantity" class="form-label">商品数量</label>
        <input type="number" class="form-control" id="quantity" v-model="quantity" min="0" required>
        <div class="text-danger" v-if="quantityError">请输入有效的商品数量</div>
      </div>
      <div class="mb-3">
        <label for="account" class="form-label">账号</label>
        <input type="text" class="form-control" id="account" v-model="account" required>
        <div class="text-danger" v-if="accountError">请输入账号</div>
      </div>
      <div class="mb-3">
        <label for="type" class="form-label">类型</label>
        <select class="form-select" id="type" v-model="type" required>
          <option value="1" selected>普通奖励</option>
          <option value="10">充值领取</option>
          <option value="11">直播奖励363</option>
          <option value="88">直播奖励270</option>
        </select>
        <div class="text-danger" v-if="typeError">请选择类型</div>
      </div>
      <div class="mb-3">
        <label for="amount" class="form-label">金额</label>
        <input type="number" class="form-control" id="amount" v-model="amount" step="1">
        <!-- 删除: <div class="text-danger" v-if="amountError">请输入金额</div> -->
      </div>
      <button type="submit" class="btn btn-primary w-100">添加商品</button>
    </form>
  </div>
</template>

<script>
import productApi from '../api/xuanchuan' // 假设这是你的商品API导入

export default {
  data() {
    return {
      productId: '',
      quantity: '',
      account: '',
      type: '1', // 初始化为第一项的值
      amount: '',
      productIdError: false,
      quantityError: false,
      accountError: false,
      typeError: false,
    };
  },
  methods: {
    submitForm() {
      // 清除之前的错误提示
      this.productIdError = false;
      this.quantityError = false;
      this.accountError = false;
      this.typeError = false;

      // 验证表单
      if (!this.productId) {
        this.productIdError = true;
      }
      if (this.quantity < 0) {
        this.quantityError = true;
      }
      if (!this.account) {
        this.accountError = true;
      }
      if (!this.type) {
        this.typeError = true;
      }

      // 如果有错误，停止提交
      if (this.productIdError || this.quantityError || this.accountError || this.typeError) {
        return;
      }
      // 创建表单数据对象
      const formData = {
        pId: this.productId,
        count: this.quantity,
        account: this.account,
        type: this.type,
        trueMoney: this.amount?this.amount:0
      };

      // 提交表单
      productApi.add(formData).then((response) => {
        console.log('商品添加成功:', response);
        alert('商品添加成功');
        // 重置表单
        this.resetForm();
      }).catch((error) => {
        console.error('商品添加失败:', error);
        alert('商品添加失败，请重试');
      });
    },
    resetForm() {
      this.productId = '';
      this.quantity = '';
      this.account = '';
      this.type = '1'; // 重置为第一项的值
      this.amount = '';
    }
  }
};
</script>

<style scoped>
.main-container {
  max-width: 800px;
  margin: 2rem auto;
  padding: 20px;
}
.form-label {
  font-weight: bold;
}
.form-control {
  width: 100%;
  padding: 0.5rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.form-select {
  width: 100%;
  padding: 0.5rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.btn-primary {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.btn-primary:hover {
  background-color: #0069d9;
  border-color: #0062cc;
}
.text-danger {
  color: #dc3545;
}
</style>

